import {ads_config, selectors} from "./config"
import i18next from 'i18next';

import {countStatuses, createCategoryTree, processAds, STATUS_GROUPS} from "./data-processing"
import {trimStr} from "./utils";
import urls from "../../common/js/urls";
import {
    expiredAccountsHtml,
    expiredAndInactiveAccountsHtml,
    inactiveAccountsHtml,
    noAccountsHtml
} from "../../common/js/dom-manipulation";
import {formatTimeString} from "../../common/js/utils";


function removeSelectedStyles(target, selectedStyles) {
    for (let style of selectedStyles) {
        target.style.removeProperty(style);
    }
}

function copySelectedStyles(source, target, selectedStyles) {
    const sourceStyles = window.getComputedStyle(source);

    for (let style of selectedStyles) {
        target.style.setProperty(style, sourceStyles.getPropertyValue(style));
    }
}

export function makeSticky() {
    let bulkContainer = $(selectors.bulkContainer);
    bulkContainer.addClass('sticky');
    const stylesToCopy = ['width', 'max-width', 'min-width', 'padding', 'margin'];
    const sourceDiv = document.querySelector('.container-xl');
    const targetDiv = document.querySelector('.bulk-top');
    let sidebar = document.getElementById('accordionSidebar') // Get the width of the sidebar
    let stickyElement = document.getElementsByClassName('sticky')[0];
    stickyElement.style.left = '0';


    if (sidebar) {
        let sidebarWidth = sidebar.offsetWidth ? sidebar.offsetWidth : 0;
        let isSidebarVisible = !sidebar.classList.contains('hidden');
        stickyElement.style.left = isSidebarVisible ? sidebarWidth + 'px' : '0';

        let sidebarButton = document.getElementById('sidebarToggle');
        sidebarButton.addEventListener('click', function () {
            let sidebarWidth = sidebar.offsetWidth;
            let isSidebarVisible = !sidebar.classList.contains('hidden');
            stickyElement.style.left = isSidebarVisible ? sidebarWidth + 'px' : '0';
        });
    }


    bulkContainer.removeClass('sticky');

    let elementOffset = $('#bulk-test').offset().top;
    $(window).on('scroll', function () {
        let scrollTop = $(window).scrollTop();

        if (scrollTop > elementOffset && elementOffset >= 0) {
            if (!bulkContainer.hasClass('sticky')) {
                bulkContainer.addClass('sticky');
                copySelectedStyles(sourceDiv, targetDiv, stylesToCopy);
                setTimeout(() => {
                    bulkContainer.addClass('show');
                }, 10);
            }
        } else {
            if (bulkContainer.hasClass('sticky')) {
                bulkContainer.removeClass('sticky');
                removeSelectedStyles(targetDiv, stylesToCopy);

                if (bulkContainer.hasClass('show')) {
                    setTimeout(() => {
                        bulkContainer.removeClass('show');
                    }, 200);
                }
            }
        }
    });
}

export function hideBulk() {
    const bulkText = $('.bulk-text');
    const bulkActions = $('.bulk-actions');
    bulkText.removeClass('invisible');
    bulkText.addClass('visible');
    bulkActions.addClass('invisible');
    bulkActions.removeClass('visible');
}

export function showBulk() {
    const bulkText = $('.bulk-text');
    const bulkActions = $('.bulk-actions');
    bulkText.removeClass('visible');
    bulkText.addClass('invisible');
    bulkActions.removeClass('invisible');
    bulkActions.addClass('visible');
}

export function displayAdsCount(quantity) {
    const translation = i18next.t('ads:dom.displayAdsCountTitle', {quantity: quantity}) // Всего объявлений: quantity
    $('.result-text-span').text(translation)
}

export function displayAdsCountByStatus(tabVisibilityState) {
    const counts = tabVisibilityState && tabVisibilityState.counts
        ? tabVisibilityState.counts
        : countStatuses({...STATUS_GROUPS}, []);
    const tabMap = {
        active: 'tab-btn-1',
        waiting: 'tab-btn-2',
        unpaid: 'tab-btn-3',
        inactive: 'tab-btn-4',
        rejected: 'tab-btn-5',
        orphaned: 'tab-btn-6',
        other_status: 'tab-btn-7',
    };

    const orphanedTabInput = $('#tab-btn-6');
    const orphanedTabLabel = $(`label[for='tab-btn-6']`);
    const hasOrphanedStatuses = Boolean(tabVisibilityState && tabVisibilityState.showOrphanedTab);
    const otherTabInput = $('#tab-btn-7');
    const otherTabLabel = $(`label[for='tab-btn-7']`);
    const hasOtherStatuses = Boolean(tabVisibilityState && tabVisibilityState.showOtherStatusTab);

    if (hasOrphanedStatuses) {
        orphanedTabInput.show();
        orphanedTabLabel.show();
    } else {
        if (orphanedTabInput.is(':checked')) {
            $('#tab-btn-1').prop('checked', true);
        }
        orphanedTabInput.hide();
        orphanedTabLabel.hide();
    }

    if (hasOtherStatuses) {
        otherTabInput.show();
        otherTabLabel.show();
    } else {
        if (otherTabInput.is(':checked')) {
            $('#tab-btn-1').prop('checked', true);
        }
        otherTabInput.hide();
        otherTabLabel.hide();
    }

    for (const [category, tabId] of Object.entries(tabMap)) {
        if (category === 'orphaned' && !hasOrphanedStatuses) {
            continue;
        }
        if (category === 'other_status' && !hasOtherStatuses) {
            continue;
        }
        const label = $(`label[for='${tabId}']`);
        let text = label.text();
        text = text.replace(/\(\d+\)/, '');
        if (counts[category] > 0) {
            label.text(`${text} (${counts[category]})`);
        } else {
            label.text(text);
        }
    }
}

export function displayError(text = 'Error') {

    displayAlert(text, 'alert-danger')


}


export function displayAlert(text, className) {
    const alertContainerHtml = '<div class="d-flex justify-content-center align-items-center bottom-0 vw-100 position-fixed alert-container" style="z-index: 9999;"></div>'
    const alertHtml = `<div class="alert ${className} alert-dismissible fade show" role="alert" style="min-width: 620px">
  <strong>${text}</strong>
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>`

    let alertContainer = $(alertContainerHtml);
    alertContainer.append($(alertHtml));
    $('#content').prepend(alertContainer)


    setTimeout(function () {

        $(`.${className}`).alert('close');
        $('.alert-container').remove();

    }, 1700);
}


export function displayAdOverlay(ad_id, bg_selector, message = "") {
    const ad_selector = '#ad_id_' + ad_id;
    let overlay = $(`<div class="card-img-overlay ${bg_selector} inventory-overlay"></div><div class="position-absolute top-50 start-50 translate-middle"><h1 class="text-white text-uppercase">${message}</h1></div>`)
    $(ad_selector).find('.inventory').prepend(overlay);

}

export function createBotDataSection(bot_name, bot_id, connected_to) {
    const inventoryConnectedBotTitleTran = i18next.t('ads:dom.inventoryConnectedBotTitle') // Подключен бот
    const inventoryConnectedBotDateTitleTran = i18next.t('ads:dom.inventoryConnectedBotDateTitle') // Подключен бот
    return bot_name ? `<div>
<span class="inventory-bot">${inventoryConnectedBotTitleTran}:</span>
<span class="inventory-bot-name"><a href="${urls.botUpdate}${bot_id}" target="_blank">${trimStr(bot_name, 60)}</a></span>
</div>
<div>
<span class="inventory-bot">${inventoryConnectedBotDateTitleTran}:</span>
<span class="inventory-bot-date">${connected_to}</span>
</div>
` : "";
}

function formatBotConnectedToStringOS(dateString) {
    //dateString = dateString.replace(' ', 'T') + 'Z'; // Convert to ISO 8601 UTC format

    let currentDate = new Date(0);
    let date = new Date(dateString);
    let connectedToDate = new Date(dateString);
    connectedToDate.setHours(0, 0, 0, 0);  //
    let formattedDate = connectedToDate.toLocaleDateString(i18next.language, {day: 'numeric', month: 'short'});

    console.log("formatBotConnectedToString", formattedDate)
    return formattedDate


}


function formatBotConnectedToHTML(dateString) {
    let date = new Date(dateString);
    let connectedToDate = new Date(dateString);
    connectedToDate.setHours(0, 0, 0, 0); // Убираем время для сравнения дат

    let now = new Date();
    now.setHours(0, 0, 0, 0); // Убираем время для текущей даты

    let tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1); // Завтрашний день

    let time = date.toLocaleTimeString(i18next.language, {hour: '2-digit', minute: '2-digit'});

     const inventoryConnectedBotTitleTodayTran = i18next.t('ads:dom.inventoryConnectedBotTitleToday')
     const inventoryConnectedBotTitleTomorrowTran = i18next.t('ads:dom.inventoryConnectedBotTitleTomorrow')

    if (connectedToDate.getTime() === now.getTime()) {
        return `<span class="inventory-bot-duration-alert">${inventoryConnectedBotTitleTodayTran} ${time}</span>`; // Сегодня 14:20
    } else if (connectedToDate.getTime() === tomorrow.getTime()) {
        return `<span class="inventory-bot-duration-alert">${inventoryConnectedBotTitleTomorrowTran} ${time}</span>`; // Завтра 14:20
    } else {
        let formattedDate = connectedToDate.toLocaleDateString(i18next.language, {day: 'numeric', month: 'short'});
        return `<span class="inventory-bot-duration">${formattedDate}</span>`; // 14 фев. 14:20
    }
}

function generateConnectedToHTML(connected_to) {
    if (!connected_to) {
        return ""
    }


}

export function createButtonSection(bot_name, bot_id, account_id, connection_id, ad_id, title, connected_to) {
// i18next-extract-mark-context: Title that describe connected bot
    const inventoryDisconnectBotButtonTran = i18next.t('ads:dom.inventoryDisconnectBotButton') // Отключить бот
    const inventoryConnectBotButtonTran = i18next.t('ads:dom.inventoryConnectBotButton') // Подключить бот
    const hasConnectedBot = Boolean(connection_id || bot_id || bot_name);


    return hasConnectedBot ? `

<div class="inventory-bot-actions">
    <button 
                type="button"
                class="inventory-btn inventory-bot-action"
                data-bs-toggle="modal"
                data-bs-target="#disconnectBotModal"
                data-account-id="${account_id}"
                data-bot-id="${bot_id}"
                data-connection-id="${connection_id}"
                data-inventory-id="${ad_id}"
                data-inventory-title="${title}"
                >${inventoryDisconnectBotButtonTran}</button>
</div>` : `<div class="inventory-bot-actions">
            <button 
                type="button"
                class="inventory-btn inventory-bot-action"
                data-bs-toggle="modal"
                data-bs-target="#connectBotModal"
                data-account-id="${account_id}"
                data-inventory-id="${ad_id}"
                data-inventory-title="${title}"
                >${inventoryConnectBotButtonTran}</button>
</div>`;

}

function createBotMetaSection(bot_name, bot_id, connection_id, connected_to) {
    const hasConnectedBot = Boolean(connection_id || bot_id || bot_name);
    if (!hasConnectedBot) {
        return "";
    }

    const inventoryConnectedBotTitleTran = i18next.t('ads:dom.inventoryConnectedBotTitle') // Подключен бот
    const inventoryConnectedBotToTitleTran = i18next.t('ads:dom.inventoryConnectedBotToTitle')

    return `<div class="inventory-bot-meta">
        <span class="inventory-bot">${inventoryConnectedBotTitleTran}:</span>
        <span class="inventory-bot-name"><a href="${urls.botUpdate}${bot_id}" target="_blank">${trimStr(bot_name, 60)}</a></span>
        <span class="inventory-bot">${inventoryConnectedBotToTitleTran} ${formatBotConnectedToHTML(connected_to)}</span>
    </div>`;
}

export function updateOrphanedAlert(orphanedCount) {
    const alert = $('#orphaned-alert');
    if (!alert.length) {
        return;
    }

    if (!orphanedCount) {
        alert.hide();
        return;
    }

    const message = i18next.t('ads:dom.orphanedAlertHtml', {count: orphanedCount});
    alert.find('.alert-message').html(message);
    alert.show();
}

function escapeHtml(value) {
    return $('<div>').text(value || "").html();
}

export function updateSyncErrorAlert(failedAccounts = []) {
    const alert = $('#ads-sync-error-alert');
    if (!alert.length) {
        return;
    }

    if (!Array.isArray(failedAccounts) || failedAccounts.length === 0) {
        alert.hide();
        alert.find('.failed-accounts-list').empty();
        return;
    }

    alert.find('.alert-message').html(i18next.t('ads:dom.adsSyncErrorAlertHtml', {url: urls.accountsPage}));

    const accountsHtml = failedAccounts.map(account => {
        const label = account.account_name || account.account_email || account.account_id || "";
        const message = account.message ? `<div class="small">${escapeHtml(account.message)}</div>` : "";
        return `<li><strong>${escapeHtml(label)}</strong>${message}</li>`;
    }).join('');

    alert.find('.failed-accounts-list').html(accountsHtml);
    alert.show();
}


// Update the UI
export function updateCategoriesUI(options) {
    let virtualSelect = document.querySelector(selectors.categories);
    virtualSelect.setOptions(options, true);

}

// Original function decomposed
export function adsCategories(ads, categories) {
    const options = getCategoriesOptions(ads, categories);
    updateCategoriesUI(options);
    return options;
}

export function getCategoriesOptions(ads, categories) {
    const allCategories = categories;
    const uniqueAdsCategoriesIds = [...new Set(ads.map(obj => obj.category_id))];

    let result = [];
    for (const id of uniqueAdsCategoriesIds) {
        let category = allCategories.find(item => item.id === id);
        if (category) {
            result.push({'label': category.name, 'value': category.id});
        }
    }
    return result;
}

export function displayAds(ads) {
    const $adsList = $(selectors.adsList);
    $adsList.empty();
    $('#bulk_container').hide();
    $('#bottom').hide();

    if (ads.length > 0) {
        $('#bulk_container').show();
        $('#bottom').show();
        $.each(ads, function (index, ad) {
            const adHtml = generateAdHtml(ad);
            $adsList.append(adHtml);
        });
    } else if (ads_config.all_ads.length > 0) {
        const translation = i18next.t('ads:dom.noMatchedFilteredAdsText') // No ads match the current filter criteria or search query.

        $adsList.append(`<span class="mt-3">${translation}</span>`);
    } else {
        const translation = i18next.t('ads:dom.noResultAdsText'); // No results were found.
        $adsList.append(`<span>${translation}</span>`);
    }
}

export function generateAdHtml(ad) {
    const images = Array.isArray(ad.images) ? ad.images : [];
    const firstImageUrl = images.length > 0 && images[0] ? images[0].url : "";
    const imageSection = firstImageUrl ? `<img class="inventory-img" src="${firstImageUrl}" alt="${ad.title || ''}">` : '<div class="inventory-img"></div>';

    const price = ad.price || {value: 0, currency: "UAH"};
    const priceValue = Number(price.value) || 0;
    const priceCurrency = price.currency || "UAH";
    const priceSection = priceValue > 0 ? `<div class="inventory-price">${priceValue} ${ads_config.currencies[priceCurrency] || priceCurrency}</div>` : '<div class="inventory-price"></div>';

    const locationNames = ad.location_names || {city_name: "", region_name: "", district_name: ""};
    const hasDistrict = Boolean(locationNames.district_name);
    const hasLocation = Boolean(locationNames.city_name || locationNames.region_name || locationNames.district_name);
    const locationSection = !hasLocation
        ? ''
        : hasDistrict
        ? `<span class="inventory-location-city">${locationNames.city_name}</span><span class="inventory-location-district">, ${locationNames.district_name}</span><span class="inventory-location-region">, ${locationNames.region_name}</span>`
        : `<span class="inventory-location-city">${locationNames.city_name}</span><span class="inventory-location-region">, ${locationNames.region_name}</span>`;

    const activatedAt = typeof ad.activated_at === "string" ? ad.activated_at.split(" ")[0] : "";
    const validTo = typeof ad.valid_to === "string" ? ad.valid_to.split(" ")[0] : "";
    const durationText = activatedAt ? `${activatedAt} - <span class="no-break">${validTo}</span>` : `<span class="no-break">${validTo}</span>`;

    let botButtonSection = createButtonSection(ad.bot_name, ad.bot_id, ad.account_id, ad.connection_id, ad.id, ad.title, ad.connected_to);
    const botMetaSection = createBotMetaSection(ad.bot_name, ad.bot_id, ad.connection_id, ad.connected_to);
    const accountTitleTextInAdCardTran = i18next.t('ads:dom.accountTitleTextInAdCard'); //
    const titleHtml = ad.url
        ? `<a href="${ad.url}" class="" target="_blank">${ad.title}</a>`
        : `<span>${ad.title}</span>`;

    return `
<div class="inventory-row" id="ad_id_${ad.id}">
    <div class="inventory-checkbox">
        <input class="form-check-input ogo-checkbox big-switch" type="checkbox" value="${ad.id}">
    </div>
    <div class="inventory ml-2">
        <div class="">
            <div class="inventory-top d-flex">
                <div>${imageSection}</div>
                <div class="inventory-data">
                    <div class="inventory-title">
                        ${titleHtml}
                        ${priceSection}
                    </div>
                    <div class="inventory-detail d-flex justify-content-between">
                        <div class="inventory-detail-left">
                            <ul class="inventory-category">${createCategoryTree(ad.category_id)}</ul>
                            <div class="inventory-location">${locationSection}</div>
                            <div class="inventory-duration">
                                <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="css-1tq7vpq"><path d="M8.006 2v1h8.007V2h2.002v1h2.984L22 4v17l-1 1H3l-1-1V4l1-1h3.004V2h2.002zm11.992 8H4.002v10h15.996V10zM7.505 12a1.5 1.5 0 1 1 .001 3 1.5 1.5 0 0 1 0-3.001zM6.004 5H4.002v3h15.996V5h-1.983v1l-1.001 1-1.001-1V5H8.006v1L7.005 7 6.004 6V5z" fill="currentColor" fill-rule="evenodd"></path></svg>
                                <div class="inventory-duration-dates">${durationText}</div>
                            </div>
                        </div>
                        <div class="inventory-detail-right">
                            <div class="account-data d-flex justify-content-end"></div>
                            <div class="account-data d-flex justify-content-end"></div>
                        </div>
                        ${botMetaSection}
                        </div>
                    </div>
                </div>
            </div>
            <div class="inventory-bottom d-flex justify-content-between">
            <div><span class="inventory-id">ID: ${ad.id}</span>
            
                        <div class="account-name" title="${ad.account_email}">${accountTitleTextInAdCardTran}: ${ad.account_name}</div>
      
                    </div>
        <div class="button-section d-flex justify-content-end align-items-center flex-wrap inventory-card-actions">
        ${botButtonSection}
</div>
                         
                
            </div>
        </div>
    </div>
</div>
`;
}

export function handleCheckboxes() {

    const $inventoryCheckbox = $('.inventory-checkbox');
    const $inventoryCheckboxChecked = $('.inventory-checkbox input:checked');

    let numAll = $inventoryCheckbox.length;
    let numChecked = $inventoryCheckboxChecked.length;

    ads_config.dataToConnectBulk = [];
    ads_config.dataToDisconnectBulk = [];

    $('.bulk-label input').prop('checked', numAll !== 0 && numAll === numChecked);

    console.log('numChecked', numChecked);

    let adsWithBot = 0;
    let adsWithoutBot = 0;
    const $bulkAddBotButton = $('.add-bot-button');
    const $bulkRemoveBotButton = $('.remove-bot-button');
    const $bulkAddBotButtonImg = $bulkAddBotButton.find('.bulk-button-icon');
    const $bulkRemoveBotButtonImg = $bulkRemoveBotButton.find('.bulk-button-icon');

    $bulkAddBotButton.prop("disabled", true);
    $bulkRemoveBotButton.prop("disabled", true);
    $bulkAddBotButtonImg.addClass("bulk-button-icon-disabled");
    $bulkRemoveBotButtonImg.addClass("bulk-button-icon-disabled");
    const bulkAddBotButtonTran = i18next.t('ads:dom.bulkAddBotButton') // Подключить бот
    const bulkRemoveBotButtonTran = i18next.t('ads:dom.bulkRemoveBotButton') // Отключить бот
    console.log('bulkRemoveBotButtonTran', bulkRemoveBotButtonTran)
    $bulkRemoveBotButton.find('span span').text(bulkRemoveBotButtonTran);
    $bulkAddBotButton.find('span span').text(bulkAddBotButtonTran);

    $(selectors.adsList + ' input[type="checkbox"]:checked').each(function () {
        const adRow = $(this).closest('.inventory-row');
        const button = adRow.find('.inventory-btn');
        const account_id = button.data('account-id');
        const ad_id = button.data('inventory-id')
        const bot_id = button.data('bot-id');
        const connection_id = button.data('connection-id');
        if (bot_id || connection_id) {


            const data = {
                connection_id: connection_id,
                ad_id: ad_id
            };

            ads_config.dataToDisconnectBulk.push(data);
            adsWithBot++;
        } else {
            const data = {
                account_id: account_id,
                ad_id: ad_id
            };
            ads_config.dataToConnectBulk.push(data);
            adsWithoutBot++;
        }
    });

    if (adsWithBot > 0 || adsWithoutBot > 0) {
        if (adsWithBot > 0) {
            const translation = i18next.t('ads:dom.bulkRemoveBotButtonWithQuantity', {quantity: adsWithBot}) // Disconnect bot(adsWithBot)
            console.log('bulkRemoveBotButtonWithCount translation', translation)
            $bulkRemoveBotButton.find('span span').text(translation);
            $bulkRemoveBotButton.prop("disabled", false);
            $bulkRemoveBotButtonImg.removeClass("bulk-button-icon-disabled");
        }

        if (adsWithoutBot > 0) {
            const translation = i18next.t('ads:dom.bulkAddBotButtonWithQuantity', {quantity: adsWithoutBot}) // Подключить бот(${adsWithoutBot})
            console.log('bulkAddBotButtonWithCount translation', translation)
            $bulkAddBotButton.find('span span').text(translation);
            $bulkAddBotButton.prop("disabled", false);
            $bulkAddBotButtonImg.removeClass("bulk-button-icon-disabled");
        }
        const translation = i18next.t('ads:dom.selectedAdsCountTitleWithQuantity', {quantity: numChecked}) // Выбрано объявлений: ${numChecked}
        $('.bulk-selected-text').text(translation);
        showBulk();
    } else {
        hideBulk();
    }
};

export function displayResults(results) {

    for (const result of results.results) {
        let ad_id = result.ad_id;
        if (!ad_id) {
            const translation = i18next.t('ads:dom.noAdIdInServerResponseError') // No ad id in server response
            displayError(translation);
            continue
        }


        if (!result.status.success) {
            displayAdOverlay(ad_id, 'bg-danger', result.status.description);
            continue
        }
        let bot_id = "";
        let connection_id = "";
        let bot_name = "";
        let connected_to = "";
        if (result.status.description === 'Connect') {

            bot_id = result.bot_id;
            if (!bot_id) {
                const translation = i18next.t('ads:dom.noBotIdInServerResponseError') // No bot id in server response
                displayError(translation);
                continue
            }
            connection_id = result.connection_id;
            connected_to = result.connected_to;
            console.log("displayResults result", result)
            if (!connection_id) {
                const translation = i18next.t('ads:dom.noBotIdInServerResponseError') // No bot id in server response
                displayError(translation);
                continue
            }

            const bot = ads_config.all_bots.find(b => b.id === bot_id);

            if (!bot) {
                const translation = i18next.t('ads:dom.cantFindBotWithIdError', {bot_id: bot_id}) // Can\'t find bot with id ${bot_id}
                displayError(translation);
                continue
            }

            bot_name = bot.name;
            if (!bot_name) {
                const translation = i18next.t('ads:dom.cantGetBotNameWithIdError', {bot_id: bot_id}) // Can\'t get bot name for bot with id ${bot_id}
                displayError(translation);
                continue
            }

        }


        let adIndex = ads_config.all_ads.findIndex((obj => obj.id === ad_id));
        if (adIndex === -1) {
            if (result.status.description === 'Disconnect') {
                continue
            }
            const translation = i18next.t('ads:dom.cantGetAdIndexWithIdError', {ad_id: ad_id}) // Can\'t get adIndex for ad with id ${ad_id}
            displayError(translation);
            continue
        }
        ;

        ads_config.all_ads[adIndex].bot_id = bot_id;
        ads_config.all_ads[adIndex].bot_name = bot_name;
        ads_config.all_ads[adIndex].connection_id = connection_id;
        ads_config.all_ads[adIndex].connected_to = connected_to;

        const ad_selector = '#ad_id_' + ad_id;
        const ad = ads_config.all_ads[adIndex];
        let button_html = createButtonSection(ad.bot_name, ad.bot_id, ad.account_id, ad.connection_id, ad.id, ad.title, ad.connected_to);
        let bot_meta_html = createBotMetaSection(ad.bot_name, ad.bot_id, ad.connection_id, ad.connected_to);


        let btn_section = $(ad_selector).find('.button-section');
        let detail_section = $(ad_selector).find('.inventory-detail');
        let bot_action_section = btn_section.children('.inventory-bot-actions');


        if (bot_action_section.length) {
            bot_action_section.replaceWith(button_html);
        } else {
            btn_section.append(button_html);
        }
        detail_section.children('.inventory-bot-meta').remove();
        detail_section.append(bot_meta_html);
        if (result.status.description === 'Disconnect') {
            displayAdOverlay(ad_id, 'bg-secondary');
            continue
        }
        displayAdOverlay(ad_id, 'bg-success');


    }
    ;
    setTimeout(function () {
        processAds();
    }, 1000);


};

export function displayMainContent() {
    $('#content').append(mainContentHtml())
}

export function displayTopAlert(length) {
    $('#account_filter').before(alertHtml(length));
}

export function displayNoAccounts() {
    $('#content').append(noAccountsHtml())
}


export function displayExpiredAndInactiveAccounts() {
    $('#content').append(expiredAndInactiveAccountsHtml())
}

export function displayExpiredAccounts() {
    $('#content').append(expiredAccountsHtml())
}

export function displayInactiveAccounts() {
    $('#content').append(inactiveAccountsHtml())
}

export function alertHtml(expiredLength) {
    const translation = i18next.t('ads:dom.expiredAccountsAlertHtml', {count: expiredLength, url: urls.accountsPage})
    // <strong>Внимание!</strong> У вас есть <a class="alert-link" href="${urls.accountsPage}"><strong>аккаунты
    //                 (${expiredLength})</strong></a>, с истекшим сроком действия! <a class="alert-link"
    //                                                                                              href="#">Обновите
    //                 их или отключите</a>, что бы не видеть это сообщение.
    return `<div class="alert alert-warning alert-dismissible fade show" role="alert">
                ${translation}
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>`;

}

export function mainContentHtml() {
    const activeTabTitleTran = i18next.t('ads:dom.activeTabTitle') // Активные
    const waitingTabTitleTran = i18next.t('ads:dom.waitingTabTitle') // Ожидающие
    const unpaidTabTitleTran = i18next.t('ads:dom.unpaidTabTitle') // Неоплаченные
    const inactiveTabTitleTran = i18next.t('ads:dom.inactiveTabTitle') // Неактивные
    const rejectedTabTitleTran = i18next.t('ads:dom.rejectedTabTitle') // Отклоненные
    const orphanedTabTitleTran = i18next.t('ads:dom.orphanedTabTitle')
    const otherStatusTabTitleTran = i18next.t('ads:dom.otherStatusTabTitle')

    const searchPlaceholderTran = i18next.t('ads:dom.searchPlaceholder') // Поиск
    const searchAttrTitleTran = i18next.t('ads:dom.searchAttrTitle') // Поиск по заголовку, ID объявления, имени аккаунта, ID аккаунта, имени бота, ID бота
    const allAdsTitleTran = i18next.t('ads:dom.allAdsTitle') // Всего объявлений
    const bulkTextTran = i18next.t('ads:dom.bulkText') // Выберите объявления из списка, чтобы осуществить групповые действия
    //console.log('bulkTextTran', bulkTextTran)
    const bulkAddBotButtonTran = i18next.t('ads:dom.bulkAddBotButton') // Подключить бот
    const bulkRemoveBotButtonTran = i18next.t('ads:dom.bulkRemoveBotButton') // Отключить бот

    const spinnerLoadingTextTran = i18next.t('ads:dom.spinnerLoadingText') // Loading

    return `            <div class="container-xl"> <div id="account_filter" class="mb-3 ">
            <div class="filter d-flex flex-wrap">
                <div id="accounts-select" class="col-12 col-md-4 filter-element"></div>
                <div id="bot-presence-select" class="col-12 col-md-4 filter-element"></div>
                <div class="bot-select col-12 col-md-4 filter-element">
                    <div id="bot-id-select" class="sometest"></div>
                </div>
            </div>



            </div>
            <div id="ads-sync-error-alert" class="alert alert-warning mb-3" style="display: none">
                <div class="d-flex flex-column gap-2">
                    <span class="alert-message"></span>
                    <ul class="failed-accounts-list mb-0"></ul>
                </div>
            </div>
            <div id="orphaned-alert" class="alert alert-warning mb-3" style="display: none">
                <div class="d-flex flex-wrap align-items-center gap-2">
                    <span class="alert-message"></span>
                    <div class="d-inline-flex flex-wrap align-items-center gap-2 orphaned-alert-actions">
                        <a href="#" class="alert-link orphaned-tab-link">${i18next.t('ads:dom.orphanedAlertViewLink')}</a>
                        <span aria-hidden="true">·</span>
                        <a href="#"
                           class="alert-link orphaned-disconnect-all-btn"
                           data-bs-toggle="modal"
                           data-bs-target="#disconnectBotModal">
                            ${i18next.t('ads:dom.orphanedAlertDisconnectAllLink')}
                        </a>
                    </div>
                </div>
            </div>
            <div id="adds_state" class="mb-3 filter" role="tablist">


                <input type="radio" name="tab-btn" id="tab-btn-1" value="active" checked>
                <label for="tab-btn-1" class="btn-radio btn-link-radio">${activeTabTitleTran}</label>

                <input type="radio" name="tab-btn" id="tab-btn-2" class="btn-check" value="waiting">
                <label for="tab-btn-2" class="btn-radio btn-link-radio">${waitingTabTitleTran}</label>

                <input type="radio" name="tab-btn" id="tab-btn-3" class="btn-check" value="unpaid">
                <label for="tab-btn-3" class="btn-radio btn-link-radio">${unpaidTabTitleTran}</label>

                <input type="radio" name="tab-btn" id="tab-btn-4" class="btn-check" value="inactive">
                <label for="tab-btn-4" class="btn-radio btn-link-radio">${inactiveTabTitleTran}</label>

                <input type="radio" name="tab-btn" id="tab-btn-5" class="btn-check" value="rejected">
                <label for="tab-btn-5" class="btn-radio btn-link-radio">${rejectedTabTitleTran}</label>

                <input type="radio" name="tab-btn" id="tab-btn-6" class="btn-check" value="orphaned" style="display: none">
                <label for="tab-btn-6" class="btn-radio btn-link-radio" style="display: none">${orphanedTabTitleTran}</label>

                <input type="radio" name="tab-btn" id="tab-btn-7" class="btn-check" value="other_status" style="display: none">
                <label for="tab-btn-7" class="btn-radio btn-link-radio" style="display: none">${otherStatusTabTitleTran}</label>


            </div>
            <div id="adds_search" class="mb-2 d-flex flex-wrap">

                <div class="col-12 col-md-4 filter-element">
                    <div class="search-group">
                        <input class="form-control og-input" id="search" type="text" placeholder="${searchPlaceholderTran}" maxlength="120"
                               title="${searchAttrTitleTran}">
                        <div class="input-clear-button invisible"><i class="input-clear-icon"></i></div>
                    </div>
                </div>

                <div class="catfilter col-12 col-md-4 filter-element">
                    <div id="categories-select" class="vs-select vs-select-bootstrap5"></div>
                </div>

                <div id="sorting" class="col-12 col-md-4 filter-element"></div>


            </div>
            <div>
                <div class="result-text">
                    <div class="result-text-1">
                        <span class="result-text-span">${allAdsTitleTran}:</span>
                        <div class="result-text-2"></div>
                    </div>
                </div>
            </div>
            <div id="bulk-test">
                <div id="bulk_container" style="display: none">
                    <div class="bulk-top" style="">

                        <div class="bulk-1" style="">


                            <div class="bulk-2">
                                <div class="bulk-3">
                                    <label class="bulk-label">
                                        <input size="25" class="form-check-input ogo-checkbox big-switch" type="checkbox"
                                               value="all">
                                    </label>
                                    <span class="bulk-text">${bulkTextTran}</span>
                                </div>

                                <div class="d-flex align-items-center bulk-actions invisible"><span
                                        class="bulk-selected-text"></span>
                                    <ul class="d-flex bulk-action-element">
                                        <li class="d-flex bulk-li">
                                            <button type="button" class="bulk-button add-bot-button" disabled
                                                    data-bs-toggle="modal" data-bs-target="#connectBotModal">
                                                <img class="bulk-button-icon" src="/static/img/connect.svg">
                                                <span class="d-flex flex-column"><span>${bulkAddBotButtonTran}</span>
                                        <i class="css-19ahzh2"></i></span></button>
                                        </li>
                                        <li class="d-flex bulk-li">
                                            <button type="button" class="bulk-button remove-bot-button" disabled
                                                    data-bs-toggle="modal" data-bs-target="#disconnectBotModal">
                                                <img class="bulk-button-icon" src="/static/img/disconnect.svg">
                                                <span class="d-flex flex-column"><span>${bulkRemoveBotButtonTran}</span>
                                        <i class="css-19ahzh2"></i></span></button>
                                        </li>
                                    </ul>
                                </div>
                            </div>


                        </div>

                    </div>
                </div>
            </div>
            <div id="inventory-list" class="mb-3"></div>
            <div id="spinner" style="display: none; padding: 40px">
            <div class="d-flex justify-content-center"><div class="spinner-border og-color" style="width: 8rem; height: 8rem;" role="status">
  <span class="visually-hidden">${spinnerLoadingTextTran}...</span>
</div></div>
            </div>
            <div id="bottom" style="display: none">
                <div class="d-flex align-content-between">
                    <span class="result-text-span"></span>
                    <!-- Paginator -->
                    <div class="container-xl align-items-center">
                        <nav id="pagination"></nav>
                    </div>

                    <div>

                        <ul id="limit-select" class="d-flex align-items-center limit-select">
                            <li class="d-flex align-items-center justify-content-center page-limit page-limit-selected">
                                50
                            </li>
                            <li class="d-flex align-items-center justify-content-center page-limit">100</li>
                            <li class="d-flex align-items-center justify-content-center page-limit">200</li>
                        </ul>
                    </div>
                </div>


            </div>
            </div>`

}


function noBotsHtml() {
    return `<div id="noBots" class="align-items-center" style="text-align: center; display: none">
                        <div><strong>У вас пока нет ботов.</strong></div>
                        <div><p>Добавьте свой первый бот прямо сейчас.</p></div>
                        <div><p><a class="btn btn-primary text-nowrap" role="button" target="_blank"
                                   href="{% url 'bot_create' %}"
                        >Добавить бот
                        </a></p></div>
                    </div>`
}

function noConnectionsHtml() {
    return `<div id="noConnections" style="display: none">
                        <div><strong>У вас нет свободных подключений</strong></div>
                        <div><p>Купите новые подключения или освободите подключения отключив бот от ненужного
                            объявления.</p></div>
                        <div><p><a class="btn btn-primary text-nowrap" role="button" target="_blank"
                                   href="{% url 'bot_create' %}"
                        >Добавить бот
                        </a></p></div>
                    </div>`
}

function lowConnectionsHtml() {
    return `<div id="lowConnections" style="display: none">
                        <div><strong>У вас мало свободных подключений!</strong></div>
                        <div><p class="message">Выбрано <strong class="selected-inventories"></strong>, но у вас есть всего <strong class="free-connections"></strong>
                            подключений</p>
                            <p>Купите новые подключения или освободите подключения отключив бот от ненужного
                                объявления.</p></div>
                        <div><p><a class="btn btn-primary text-nowrap" role="button" target="_blank"
                                   href="{% url 'bot_create' %}"
                        >Добавить бот
                        </a></p></div>
                    </div>`
}

function modalSpinnerHtml() {
    return `<div class="d-flex justify-content-center">
                        <div class="spinner-border og-color" role="status" style="width: 7rem; height: 7rem;">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>`
}
